import { render, staticRenderFns } from "./ScreenPrefacturas.vue?vue&type=template&id=573e529c"
import script from "./ScreenPrefacturas.vue?vue&type=script&lang=js"
export * from "./ScreenPrefacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports